import { useTranslation } from 'react-i18next'

import * as styles from './GretaAIChatFeedbackPrivacy.module.css'

function GretaAIChatFeedbackPrivacy() {
  const { t } = useTranslation()

  return <div className={styles.privacy}>{t('Greta.FeedbackPrivacyKey')}</div>
}

export default GretaAIChatFeedbackPrivacy
